export class PriceModel {
  amount: number;
  currencyCode: string;

  constructor() {
    this.amount = undefined;
    this.currencyCode = undefined;
  }
}
